module.exports = __webpack_public_path__ + "static/media/I-Cable_HongKong.1e00e680.png";